import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  overflow-x: hidden;
  width: 100%;
  background: transparent
    linear-gradient(
      180deg,
      ${(props) => props.theme.palette.primary.contrastText} 0%,
      ${(props) => props.theme.palette.gray5} 100%
    )
    0% 0% no-repeat padding-box;
  @media (min-width: 760px) {
    width: 420px;
    margin: 0 auto;
    flex-direction: column;
    border: 1px solid #80808078;
  }
`;
